<template>
  <div>
    <modal
      class="modal-initial"
      style="modal"
      name="initial-offline-modal"
      :width="modalWidth"
      height="auto"
      display="flex"
      :pivot-y="0.5"
      :scrollable="true"
      :clickToClose="true"
      @closed="closeModal"
    >
      <div class="box">
        <h3 class="smokeheadlineh3">
          {{ $t("initial_modal_headline") }}
        </h3>

        <div class="installGuideContainer">
          <div
            class="browserInstallGuide"
            v-for="browser in browserInstallData"
            :key="browser.headline"
          >
            <p class="installGuideHeadline">
              {{ $t(browser.headline) }}
            </p>

            <p v-for="count in browser.steps" :key="count">
              {{ $t(browser.installStepTitle + count) }}
            </p>
          </div>
        </div>

        <p class="mb-4">{{ $t("initial_modal_instalguide_info") }}</p>
        <p class="installGuideHeadline">
          {{ $t("initial_modal_offline_usage_headline") }}
        </p>
        <p>{{ $t("initial_modal_offline_usage_info") }}</p>

        <div class="d-flex">
          <button class="saveButton" @click="closeModal">
            <p>{{ $t("close") }}</p>
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { storageAdapter } from "@/services/storageAdapter";
export default {
  name: "InitialOfflineModal",

  data() {
    return {
      allowedLanguages: ["de", "en"],
      browserInstallData: [
        {
          headline: "install_guide_headline_safari",
          steps: 3,
          installStepTitle: "install_steps_safari"
        },
        {
          headline: "install_guide_headline_chrome",
          steps: 2,
          installStepTitle: "install_steps_chrome"
        },
        {
          headline: "install_guide_headline_firefox",
          steps: 2,
          installStepTitle: "install_steps_firefox"
        }
      ]
    };
  },
  computed: {
    modalWidth() {
      if (window.innerWidth <= 575) {
        return "100%";
      } else {
        return "70%";
      }
    }
  },
  methods: {
    closeModal() {
      storageAdapter("offlineModeWasInitialized").set("true");
      this.$store.state.wasOfflineModeInitialized = storageAdapter(
        "offlineModeWasInitialized"
      ).get();
      this.$modal.hide("initial-offline-modal");
      this.$modal.show("sarsCoV-modal");
    }
  }
};
</script>

<style scoped>
.modal-initial {
  z-index: 1040;
  height: 100% !important;
  min-height: 100% !important;
  overflow-y: auto;
}
.smokeheadlineh3 {
  text-align: left;
  color: limegreen;
  font-family: Netto Bold, Open Sans, sans-serif;
}
.box {
  margin: 5%;
}
.saveButton {
  color: #00aeef;
  margin-left: auto;
  margin-top: 1rem;
}

.installHeadline {
  font-family: Netto Bold, Open Sans, sans-serif;
  margin-bottom: 1.5rem;
}
.browserInstallGuide {
  margin-bottom: 1.5rem;
}
.installGuideHeadline {
  font-family: Netto Bold, Open Sans, sans-serif;
}

.installGuideContainer {
  padding-top: 2rem;
}
</style>
